// @ts-nocheck
//测试环境
//const baseURL = "https://test.lanmor.cn/api/";
const baseURL = "https://s2022.lanmor.cn/api/";
export const Api = {
  lanmor: {
    getsign: baseURL + "getsign.aspx", //获取微信config参数
    getImageCode: baseURL + "getImageCode.aspx", //获取图片验证码
    getSms: baseURL + "getSms.aspx", //获取短信验证码
    login: baseURL + "login.aspx", //手机号登录
    index: baseURL + "index.aspx", //获取首页数据
    shopList: baseURL + "shopList.aspx", //商家列表
    lottery: baseURL + "lottery.aspx", //抽奖
    uploadCheck: baseURL + "user/uploadCheck.aspx", //校验是否可上传消费券
    upload: baseURL + "user/upload.aspx", //上传消费券
    userInfo: baseURL + "user/info.aspx", //我的信息
    couponList: baseURL + "user/couponList.aspx", //的消费券列表
    vouchers: baseURL + "user/vouchers.aspx", //我的账单列表
    updateOpenId: baseURL + "user/updateOpenId.aspx", //更新openid
    invest_url: baseURL + "invest_url.aspx", //获取问卷调查链接
    invest_detail: baseURL + "invest_detail.aspx", //调查问卷详情 
    invest_submit: baseURL + "invest_submit.aspx", //提交问卷调查
    invest_result: baseURL + "invest_result.aspx", //调查问卷结果
    click_navigation: baseURL + "click.aspx", //导航点击
    click_type: baseURL + "click_type.aspx", //板块点击
    click_search: baseURL + "click_search.aspx", //搜索点击
    resources: baseURL + "resources.aspx", //获取静态资源数据
  },
  business: {
    login: baseURL + "business/login.aspx", //商户登录
    info: baseURL + "business/info.aspx", //商户信息
    typelist: baseURL + "business/type_list.aspx", //类别列表
    salesubmit: baseURL + "business/sale_submit.aspx", //提交销售数据
    saledetailsubmit: baseURL + "business/sale_detail_submit.aspx", //根据类别提交销售明细数据
    sales: baseURL + "business/sales.aspx", //销售记录(只能修改当天的数据)
    salestatistic: baseURL + "business/sale_statistic.aspx", //销售统计

    new_apply_config: baseURL + "business_new/apply_config.aspx", //(新)加载数据录入
    new_apply_submit: baseURL + "business_new/apply_submit.aspx", //(新)数据提交
    new_shop_type: baseURL + "business_new/shop_type.aspx", //(新)商户类别
    new_area: baseURL + "business_new/area.aspx", //(新)区域
    new_street: baseURL + "streetList.aspx", //(新)街道
    new_register: baseURL + "business_new/register.aspx", //(新)商户注册
    new_tab_list: baseURL + "business_new/tab_list.aspx", //(新)tab列表
    new_change_user: baseURL + "business_new/change_user.aspx", //(新)变更商户联系人
    new_data_list: baseURL + "business_new/data_list.aspx", //(新)获取预估/实际记录列表
    new_data_detail: baseURL + "business_new/data_detail.aspx", //(新)获取预估数据/实际数据详情
  },
  guess: {
    regular: baseURL + "guess/regular.aspx", //规则
    list: baseURL + "guess/list.aspx", //竞猜列表
    submit: baseURL + "guess/submit.aspx", //提交竞猜
    my_guess: baseURL + "guess/my_guess.aspx", //我的竞猜
  },
};
window.Api = Api;
